export default {
  notANumber: '{description} must be a number (only digits or a period)',
};
